import UpdatedLegalNoticeModal from './UpdatedLegalNoticeModal';
import UpdatedTosApprovalModal from './UpdatedTosApprovalModal';

export { UpdatedLegalNoticeModal, UpdatedTosApprovalModal };
